<template>
  <div>
    <modal
      name="team-member-remove"
      :adaptive="true"
      :minHeight="400"
      :maxHeight="auto"
      :scrollable="true"
    >
      <div class="text-center mt-4">
        <h6 class="text-gray-600 text-xl font-bold">Team - {{ team.name }}</h6>
      </div>
      <div style="margin: 20px">
        <FormulateForm @submit="removeMember">
          <div class="flex flex-wrap">
            <div class="w-full xl:w-4/12 mb-12 xl:mb-0 px-2">
              <FormulateInput
                type="text"
                name="first_name"
                label="First Name"
                outer-class="mb-4"
                input-class="border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                disabled
                :value="member.first_name"
              />
            </div>
            <div class="w-full xl:w-4/12 mb-12 xl:mb-0 px-2">
              <FormulateInput
                type="text"
                name="middle_name"
                label="Middle Name"
                outer-class="mb-4"
                input-class="border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                disabled
                :value="member.middle_name"
              />
            </div>
            <div class="w-full xl:w-4/12 mb-12 xl:mb-0 px-2">
              <FormulateInput
                type="text"
                name="last_name"
                label="Last Name"
                outer-class="mb-4"
                input-class="border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                disabled
                :value="member.last_name"
              />
            </div>
            <div class="w-full xl:w-4/12 mb-12 xl:mb-0 px-2">
              <FormulateInput
                type="text"
                name="email"
                label="Email"
                outer-class="mb-4"
                input-class="border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                disabled
                :value="member.email"
              />
            </div>
            <div class="w-full xl:w-4/12 mb-12 xl:mb-0 px-2">
              <FormulateInput
                type="text"
                name="city"
                label="City"
                outer-class="mb-4"
                input-class="border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                disabled
                :value="member.city"
              />
            </div>
            <div class="w-full xl:w-4/12 mb-12 xl:mb-0 px-2">
              <FormulateInput
                type="text"
                name="country"
                label="Country"
                outer-class="mb-4"
                input-class="border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                disabled
                :value="member.country"
              />
            </div>
            <div class="w-full xl:w-12/12 mb-12 xl:mb-0 px-2">
              <FormulateInput
                type="text"
                name="description"
                label="Description"
                outer-class="mb-4"
                input-class="border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                disabled
                :value="member.description"
              />
            </div>
            <div class="w-full xl:w-12/12 xl:mb-0 px-2 mt-5">
              <FormulateInput
                input-class="px-4 py-2 w-full rounded bg-blue-500 text-white hover:bg-blue-700"
                type="submit"
                name="Remove Member"
              />
            </div>
          </div>
        </FormulateForm>
      </div>
    </modal>
  </div>
</template>
<script>
/* 
  Class: ModalTeamMemberRemove
  Description: This class representing a team member remove modal.
*/

/* Imports */
import TeamService from "@/services/team.service";
/* /Imports/ */

export default {
  /* 
    Define data with custom members state values. 
  */
  data() {
    return {
      members: [],
    };
  },

  /* 
    Define props from which we got team and member data. 
  */
  props: {
    team: null,
    member: null
  },

  methods: {
    /* 
      Call TeaemService class to remove member from the certain team.
    */
    removeMember() {
      var data = { members: [this.member.id]};

      TeamService.removeMember(this.team.id, data).then(() => {
        location.reload();
      });
    },
  }
};
</script>
